import React from "react";
import ProfilePage from "./ProfilePage/ProfilePage";

export default () => (
  <ProfilePage/>
);
